<template>
  <div
    :class="{
      'footer-bottom-wrapper px-6 pb-1': true,
    }"
  >
    <div
      :class="{
        'mx-auto flex flex-col items-center py-10 md:mt-3 md:max-w-1760px md:flex-row md:flex-wrap md:justify-center lg:mt-0 lg:flex-row lg:justify-start lg:pb-0': true,
      }"
    >
      <!-- copyright -->
      <div
        :class="{
          'relative order-3 mb-0 md:order-1 md:w-1/2 lg:mr-1/20 lg:w-auto': true,
        }"
      >
        <div
          v-if="copyright"
          :class="{
            'py-2 text-sm leading-6 text-www-color-neutral-very-light md:text-center': true,
          }"
        >
          {{ copyright }}
        </div>
      </div>
      <!-- Footnote Menu  -->
      <div
        :class="{
          'relative order-1 mb-0 w-full text-center md:order-2 md:w-2/4 lg:mr-1/20 lg:w-[37%]': true,
        }"
      >
        <ul>
          <li
            v-for="(menu, index) in footnoteLinks"
            :key="index"
            :class="{
              'mr-5 inline-block list-none last:mr-0': true,
            }"
          >
            <GeneralLink
              v-bind="menu"
              :class="{
                'ease-in hover:underline': true,
                'text-14px capitalize leading-30px text-www-color-neutral-very-light': true,
              }"
              @click="
                () => {
                  if (
                    menu.link &&
                    menu.link[0] &&
                    menu.link[0]._type === 'externalLink' &&
                    menu.link[0].url === '#cookie-settings'
                  )
                    handleOpenCookieSettings();
                }
              "
            />
          </li>
        </ul>
      </div>

      <!-- Social Icons -->
      <div
        :class="{
          'relative order-2 mb-5 mt-[1.25rem] text-right md:order-3 lg:m-0': true,
        }"
      >
        <div
          :class="{
            'flex gap-30px': true,
          }"
        >
          <SocialIcon
            v-for="(social, index) in socialIcons"
            :key="index"
            :class="{
              'max-h-8 max-w-8': true,
            }"
            v-bind="social"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { Footer } from '~/sanity/types';
import GeneralLink from '../HeaderComponents/GeneralLink.vue';
import SocialIcon from '~/components/Atoms/SocialIcon/SocialIcon.vue';
defineProps<Footer>();
const oneTrustReady = ref(false);

const pollOneTrust = () => {
  if (import.meta.server) {
    return;
  }
  const interval = setInterval(() => {
    if (!window.OneTrust) {
      return;
    }
    clearInterval(interval);
    oneTrustReady.value = true;
  }, 300);
  setTimeout(() => clearInterval(interval), 20000);
};

pollOneTrust();

const handleOpenCookieSettings = () => {
  if (import.meta.server) return;
  if (!oneTrustReady.value) {
    console.warn('OneTrust is not ready yet, cannot open cookie settings');
    return;
  }

  window.OneTrust.ToggleInfoDisplay();
};
</script>

<style></style>
